import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const updateRole = async ({
	roleId,
	permissions
}: {
	roleId: string;
	permissions: string[];
}) => {
	const response = await cmsClient.patch<RoleResponse>(`/roles/${roleId}/`, {
		permissions
	});
	return response.data;
};

const useUpdateRole = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Role updated" />, {
			hideProgressBar: true
		});
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["roles"]);
	};

	const onError = (error: unknown) => {
		const detail = (error as { response?: { data?: Record<string, unknown> } })
			?.response?.data;
		const message =
			(detail as { detail?: string })?.detail ??
			(detail ? Object.values(detail).flat().join(" ") : undefined) ??
			"Something went wrong, try again";

		toast.error(<CustomToast type="Error" message={message} />, {
			hideProgressBar: true
		});
	};

	const mutation = useMutation(updateRole, {
		onError,
		onSuccess,
		onSettled
	});

	return mutation;
};

export default useUpdateRole;
